<fui-accordion [closeOthers]="false">
  <fui-accordion-panel [isOpen]="true">
    <div title class="noselect">
      Location
      <i class="dropdown icon"></i>
    </div>
    <div content>
      <ais-hierarchical-menu
        [attributes]="[
          'screenLocation.lvl0',
          'screenLocation.lvl1',
          'screenLocation.lvl2',
          'screenLocation.lvl3'
        ]"
      ></ais-hierarchical-menu>
    </div>
  </fui-accordion-panel>
  <div class="ui divider"></div>
  <fui-accordion-panel [isOpen]="true">
    <div title class="noselect">
      City
      <i class="dropdown icon"></i>
    </div>
    <div content>
      <ais-refinement-list
        attribute="city"
        [searchable]="true"
        searchPlaceholder="Search City"
        [limit]="5"
        [showMoreLimit]="30"
      ></ais-refinement-list>
    </div>
  </fui-accordion-panel>
  <div class="ui divider"></div>
  <fui-accordion-panel [isOpen]="true">
    <div title class="noselect">
      TouchPoints
      <i class="dropdown icon"></i>
    </div>
    <div content>
      <ais-refinement-list attribute="touchPoint" [searchable]="false">
      </ais-refinement-list>
    </div>
  </fui-accordion-panel>
  <div class="ui divider"></div>
  <fui-accordion-panel [isOpen]="true">
    <div title class="noselect">
      Language
      <i class="dropdown icon"></i>
    </div>
    <div content>
      <ais-refinement-list attribute="languages"> </ais-refinement-list>
    </div>
  </fui-accordion-panel>
  <div class="ui divider"></div>
  <fui-accordion-panel [isOpen]="true">
    <div title class="noselect">
      Orientation
      <i class="dropdown icon"></i>
    </div>
    <div content>
      <ais-refinement-list attribute="screenOrientation"> </ais-refinement-list>
    </div>
  </fui-accordion-panel>
  <div class="ui divider"></div>
  <fui-accordion-panel [isOpen]="true">
    <div title class="noselect">
      Price Range
      <i class="dropdown icon"></i>
    </div>
    <div content>
      <ais-range-slider
        attribute="screenPrice"
        [pips]="false"
        [precision]="2"
      ></ais-range-slider>
    </div>
  </fui-accordion-panel>
  <div class="ui divider"></div>
  <fui-accordion-panel [isOpen]="true">
    <div title class="noselect">
      Footfall
      <i class="dropdown icon"></i>
    </div>
    <div content>
      <ais-range-slider
        attribute="monthlyFootfall"
        [pips]="false"
        [precision]="0"
      ></ais-range-slider>
    </div>
  </fui-accordion-panel>
</fui-accordion>
